<template>
    <div v-loading="loading || !results">
        <el-row style="margin-top: 30px;">
            <el-col :span="24">
                <h1 style="margin-bottom:0;">Plan</h1>
            </el-col>
        </el-row>

        <div v-if="results">
            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>PLAN</h2>
                    <el-radio-group :value="1">
                        <el-radio :label="1" >Base+ Plan $1,000</el-radio><br>
                    </el-radio-group>
                </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <h2>TERM</h2>
                <el-radio-group v-model="results.selected_term_length">
                  <el-radio :label="1">Month-to-Month /requires manager approval/</el-radio><br>
                  <el-radio :label="3">3 Months</el-radio><br>
                  <el-radio :label="6">6 Months</el-radio><br>
                  <el-radio :label="12">12 Months</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>

            <el-row v-if="results.driverboost_plans" :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                <el-col :span="8">
                    <h2>COMPANY DRIVER JOBADVISER</h2>

                    <template  v-if="results.display_driverboost_cd">
                        <p>Available: {{ results.driverboost_available.count_cd }} at $50/each</p>

                        <el-radio-group v-model="results.selected_driverboost_leads">
                            <div v-for="(driverboostPlan, index) in results.driverboost_plans.db_cd" :key="index">
                                <el-radio :label="driverboostPlan.leads" :disabled="!isDBSelectable(index, 'count_cd', 'db_cd')">{{ driverboostPlan.name }} <span v-if="driverboostPlan.monthly_price > 0">(+ {{ money(driverboostPlan.monthly_price, 0) }})</span></el-radio><br>
                            </div>
                        </el-radio-group>
                    </template>
                </el-col>
                <el-col :span="8">

                    <h2>OO &amp; LEASE PURCHASE JOBADVISER</h2>

                    <template  v-if="results.display_driverboost_oo">
                        <p>Available: {{ results.driverboost_available.count_oo }} at $75/each</p>

                        <el-radio-group v-model="results.selected_driverboost_oo_leads">
                            <div v-for="(driverboostPlan, index) in results.driverboost_plans.db_oo" :key="index">
                                <el-radio :label="driverboostPlan.leads" :disabled="!isDBSelectable(index, 'count_oo', 'db_oo')">{{ driverboostPlan.name }} <span v-if="driverboostPlan.monthly_price > 0">(+ {{ money(driverboostPlan.monthly_price, 0) }})</span></el-radio><br>
                            </div>
                        </el-radio-group>
                    </template>
                </el-col>
                <el-col :span="8">
                    <h2>INEXPERIENCED DRIVER JOBADVISER</h2>

                    <template  v-if="results.display_driverboost_student">
                        <p>Available: {{ results.driverboost_available.count_student }} at $20/each</p>

                        <el-radio-group v-model="results.selected_driverboost_student_leads">
                            <div v-for="(driverboostPlan, index) in results.driverboost_plans.db_student" :key="index">
                                <el-radio :label="driverboostPlan.leads" :disabled="!isDBSelectable(index, 'count_student', 'db_student')">{{ driverboostPlan.name }} <span v-if="driverboostPlan.monthly_price > 0">(+ {{ money(driverboostPlan.monthly_price, 0) }})</span></el-radio><br>
                            </div>
                        </el-radio-group>
                    </template>
                </el-col>
            </el-row>

            <el-row v-if="results.equipment_based_plans" :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                <el-col :span="8" v-for="(equipmentBasedPlan, index) in results.equipment_based_plans" :key="index">
                    <h2>{{ equipmentBasedPlan.name }}</h2>
                    <template>
                        <p>Available: {{ equipmentBasedPlan.estimate }} at {{ money(equipmentBasedPlan.price) }}/each</p>

                        <el-radio-group v-model="equipmentBasedPlan.leads">
                            <div v-for="(leads, index) in [0,10,15,20,25,50,100,125,175,200,250]" :key="index">
                                <el-radio :label="leads">{{ leadsPlanName(leads, equipmentBasedPlan.price) }}
                                </el-radio><br>
                            </div>
                        </el-radio-group>
                    </template>
                </el-col>
            </el-row>

            <template v-if="show_mc">
                <el-row :gutter="20" style="font-size: 1.3em; margin: 10px 0;">
                    <el-col :span="8">
                        <h2>COMPANY DRIVER MULTI-CARRIER</h2>
                        <template  v-if="results.display_driverboost_cd">
                            <p>Available: {{ results.mc_available.count_cd }} at ${{ results.mc_plans.cd[0].price }}/each</p>

                            <el-radio-group :value="mc_leads" @input="setMcLeads">
                                <div v-for="(plan, index) in results.mc_plans.cd" :key="index">
                                    <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                                </div>
                                <div>
                                    <el-radio label="custom">
                                      <el-input v-model="custom_mc_cd_leads" style="width: 100px;" /> leads
                                      <template v-if="custom_mc_cd_leads">
                                        (+ {{ money(parseInt(custom_mc_cd_leads) * mc_lead_price, 0) }})
                                      </template>
                                    </el-radio><br>
                                </div>
                            </el-radio-group>
                        </template>
                    </el-col>
                    <el-col :span="8">

                        <h2>OO &amp; LEASE PURCHASE MULTI-CARRIER</h2>

                        <template  v-if="results.display_driverboost_oo">
                            <p>Available: {{ results.mc_available.count_oo }} at ${{ results.mc_plans.oo[0].price }}/each</p>

                          <el-radio-group :value="mc_oo_leads" @input="setMcOOLeads">
                                <div v-for="(plan, index) in results.mc_plans.oo" :key="index">
                                    <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                                </div>
                              <div>
                                  <el-radio label="custom">
                                      <el-input v-model="custom_mc_oo_leads" style="width: 100px;" /> leads
                                      <template v-if="custom_mc_oo_leads">
                                          (+ {{ money(parseInt(custom_mc_oo_leads) * mc_oo_lead_price, 0) }})
                                      </template>
                                  </el-radio><br>
                              </div>
                            </el-radio-group>
                        </template>
                    </el-col>
                    <el-col :span="8">
                        <h2>INEXPERIENCED DRIVER MULTI-CARRIER</h2>

                        <template  v-if="results.display_driverboost_student">
                            <p>Available: {{ results.mc_available.count_student }} at ${{ results.mc_plans.student[0].price }}/each</p>

                            <el-radio-group :value="mc_student_leads" @input="setMcStudentLeads">
                                <div v-for="(plan, index) in results.mc_plans.student" :key="index">
                                    <el-radio :label="plan.leads">{{ plan.name }} <span v-if="plan.monthly_price > 0">(+ {{ money(plan.monthly_price, 0) }})</span></el-radio><br>
                                </div>
                                <div>
                                    <el-radio label="custom">
                                        <el-input v-model="custom_mc_student_leads" style="width: 100px;" /> leads
                                        <template v-if="custom_mc_student_leads">
                                            (+ {{ money(parseInt(custom_mc_student_leads) * mc_student_lead_price, 0) }})
                                        </template>
                                    </el-radio><br>
                                </div>
                            </el-radio-group>
                        </template>
                    </el-col>
                </el-row>
            </template>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>DISCOUNTS</h2>
                    <el-checkbox v-model="results.discounts_250_ja">
                      <b v-if="discounts_250_ja_allowed">Suggested: </b>
                      Discount $250 Waive JB fee as intro rate with purchase of 10 JA leads
                    </el-checkbox><br>
                    <el-checkbox v-model="results.discounts_500_ja">
                      <b v-if="discounts_500_ja_allowed">Suggested: </b>
                      Discount $500 Waive JB fee as intro rate with purchase of 25 JA leads
                    </el-checkbox><br>
                    <el-checkbox v-model="results.discounts_1000_ja">
                      <b v-if="discounts_1000_ja_allowed">Suggested: </b>
                      Discount $1000 Waive JB fee as intro rate with purchase of $2,500+ in JA or MC
                    </el-checkbox><br>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>ADD-ON</h2>
                    <div class="input-group">
                        <span class="input-group-addon">$</span>
                        <el-input v-model="results.addon_price"></el-input>
                    </div>                    
                    <el-form-item label="Note">
                        <el-input type="textarea" v-model="results.addon_note"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>TOTAL: {{ money(total) }}</h2>

                    <p>Gets uncapped job board, {{ allDejaLeads == 0 ? 'no' : allDejaLeads }} DEJA leads, {{ allMcLeads == 0 ? 'no' : allMcLeads }} MC.</p>

                    <p v-if="hireEstimate == 0">No hire estimate.</p>
                    <p v-if="hireEstimate > 0">Estimated hires: {{ hireEstimate }} per month.</p>
                </el-col>
            </el-row>

            <h1 style="margin-bottom: 0; margin-top: 40px;">Proposal Document</h1>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>HEADER</h2>
                    <p style="margin-top: 24px; font-weight: bold">Logo</p>
                    <el-upload
                        :action="uploadUrl"
                        list-type="picture-card"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="x => handleLogoRemove(x)"
                        :on-success="x => logoUploaded(x)"
                        :file-list="logoFileList"
                        :class="{ hideUpload: this.logoFileList.length > 0 }"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>

                    <p style="margin-top: 24px; font-weight: bold">Sign by</p>
                    <div>
                        <el-date-picker v-model="results.please_sign_by" type="date"></el-date-picker>
                    </div>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="24">
                    <h2>PRICING OPTIONS</h2>

                    <el-row :gutter="24">
                        <el-col :span="8">
                            <h3>Option 1</h3>
                        </el-col>
                        <el-col :span="8">
                            <h3>Option 2</h3>
                            <div style="margin: -16px 0 16px 0">(taken from proposal calculation above)</div>
                        </el-col>
                        <el-col :span="8">
                            <h3>Option 3</h3>
                        </el-col>
                    </el-row>

                    <el-row :gutter="24">
                        <el-col :span="8">
                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <el-input-number v-model="results.pricing_option1" :controls="false"></el-input-number>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <b>{{ money(total) }}</b>
                        </el-col>
                        <el-col :span="8">
                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <el-input-number v-model="results.pricing_option3" :controls="false"></el-input-number>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="24" style="margin-top: 20px;">
                        <el-col :span="8">
                            <div>Discounts</div>
                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <el-input-number v-model="results.discount_option1" :controls="false"></el-input-number>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div>Discounts</div>
                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <el-input-number v-model="results.discount_option2" :controls="false"></el-input-number>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div>Discounts</div>
                            <div class="input-group">
                                <span class="input-group-addon">$</span>
                                <el-input-number v-model="results.discount_option3" :controls="false"></el-input-number>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="Description">
                                <el-input type="textarea" v-model="results.pricing_option_description1" :rows="6"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Description">
                                <el-input type="textarea" v-model="results.pricing_option_description2" :rows="6"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Description">
                                <el-input type="textarea" v-model="results.pricing_option_description3" :rows="6"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <el-row style="margin-top: 30px">
                <el-col :span="24">
                    <el-form-item>
                        <btn :disabled="results.signed_at" :click="saveResults" cssClass="btn-primary btn-large">Save and Close</btn>
                        <btn :disabled="results.signed_at" :click="previewProposal"  icon="fas fa-external-link" cssClass="btn-secondary" style="margin-left: 24px">Preview Proposal</btn>
                    </el-form-item>
                </el-col>
            </el-row>

        </div>
    </div>

</template>

<script>
export default {
    components: {},
    props: [
        'id',
        'formData',
        'results',
        'show_mc'
    ],
    data() {
        return {
            loading: false,

            custom_mc_cd_leads: this.results.selected_mc_leads,
            custom_mc_oo_leads: this.results.selected_mc_oo_leads,
            custom_mc_student_leads: this.results.selected_mc_student_leads,

            discounts_250_allowed: false,
            discounts_500_allowed: false,
            discounts_waive_fee_500_allowed: false,
            discounts_waive_fee_750_allowed: false,
            is_discounts_250_visible: this.results.discounts_250,
            is_discounts_500_visible: this.results.discounts_500,
            is_discounts_waive_fee_500_visible: this.results.discounts_waive_fee_500,
            is_discounts_waive_fee_750_visible: this.results.discounts_waive_fee_750,

            uploadUrl: url("/admin/glp/upload-image"),
        }
    },
    watch: {
        custom_mc_cd_leads() {
            this.setMcLeads('custom');
        },
        custom_mc_oo_leads() {
            this.setMcOOLeads('custom');
        },
        custom_mc_student_leads() {
            this.setMcStudentLeads('custom');
        },
        'results.discounts_250_ja'(newValue) {
            if (newValue) {
                this.resetOldDiscounts();
                Vue.set(this.results, 'discounts_500_ja', false);
                Vue.set(this.results, 'discounts_1000_ja', false);
            }
        },
        discounts_250_ja_allowed() {
            if (this.results) {
                if (this.discounts_250_ja_allowed) {
                    this.results.discounts_250_ja = true;
                } else {
                    this.results.discounts_250_ja = false;
                }
            }
        },
        'results.discounts_500_ja'(newValue) {
            if (newValue) {
                this.resetOldDiscounts();
                Vue.set(this.results, 'discounts_250_ja', false);
                Vue.set(this.results, 'discounts_1000_ja', false);
            }
        },
        discounts_500_ja_allowed() {
            if (this.results) {
                if (this.discounts_500_ja_allowed) {
                    this.results.discounts_500_ja = true;
                } else {
                    this.results.discounts_500_ja = false;
                }
            }
        },
        'results.discounts_1000_ja'(newValue) {
            if (newValue) {
                this.resetOldDiscounts();
                Vue.set(this.results, 'discounts_250_ja', false);
                Vue.set(this.results, 'discounts_500_ja', false);
            }
        },
        discounts_1000_ja_allowed() {
            if (this.results) {
                if (this.discounts_1000_ja_allowed) {
                    this.results.discounts_1000_ja = true;
                } else {
                    this.results.discounts_1000_ja = false;
                }
            }
        },
        totalDiscounts() {
            this.results.discount_option2 = this.totalDiscounts;
        }
    },
    computed: {
        logoFileList: function () {
            if(! this.results.logo_url) {
                return [];
            }

            return [{
                url: this.results.logo_url
            }];
        },

        mc_leads() {
            let options = _.map(this.results.mc_plans.cd, (plan) => plan.leads);
            return (options.includes(this.results.selected_mc_leads))
              ? this.results.selected_mc_leads
              : 'custom';
        },
        mc_lead_price() {
          let prices = _.map(this.results.mc_plans.cd, (plan) => plan.price);
          return prices[0];
        },
        mc_oo_leads() {
          let options = _.map(this.results.mc_plans.oo, (plan) => plan.leads);
          return (options.includes(this.results.selected_mc_oo_leads))
              ? this.results.selected_mc_oo_leads
              : 'custom';
        },
        mc_oo_lead_price() {
          let prices = _.map(this.results.mc_plans.oo, (plan) => plan.price);
          return prices[0];
        },
        mc_student_leads() {
          let options = _.map(this.results.mc_plans.student, (plan) => plan.leads);
          return (options.includes(this.results.selected_mc_student_leads))
              ? this.results.selected_mc_student_leads
              : 'custom';
        },
        mc_student_lead_price() {
          let prices = _.map(this.results.mc_plans.student, (plan) => plan.price);
          return prices[0];
        },
        discounts_250_ja_allowed() {
            const totalBudget = this.totalDriverBoost + this.totalMultiCarrier;

            const dejaLeadsInBoundaries = this.allDejaLeads > 0 && this.allDejaLeads < 25;
            const budgetInBoundaries = totalBudget > 0 && totalBudget < 2500;
            const termMetCriteria = this.results.selected_term_length > 1;

            return dejaLeadsInBoundaries && budgetInBoundaries && termMetCriteria;
        },
        discounts_500_ja_allowed() {
            const totalBudget = this.totalDriverBoost + this.totalMultiCarrier;

            const dejaLeadsInBoundaries = this.allDejaLeads >= 25 && this.allDejaLeads < 50;
            const budgetInBoundaries = totalBudget > 0 && totalBudget < 2500;
            const termMetCriteria = this.results.selected_term_length > 1;

            return  (dejaLeadsInBoundaries && budgetInBoundaries) && termMetCriteria;
        },
        discounts_1000_ja_allowed() {
            const totalBudget = this.totalDriverBoost + this.totalMultiCarrier;

            const dejaLeadsInBoundaries = this.allDejaLeads >= 50;
            const budgetInBoundaries = this.totalMultiCarrier > 0 && totalBudget > 2500;
            const termMetCriteria = this.results.selected_term_length > 1;
            console.log(this.allDejaLeads);

            return  (dejaLeadsInBoundaries || budgetInBoundaries) && termMetCriteria;
        },
        allDejaLeads() {
            if (this.results.driverboost_plans) {
                return this.results.selected_driverboost_leads + this.results.selected_driverboost_oo_leads + this.results.selected_driverboost_student_leads;
            }
            if (this.results.equipment_based_plans) {
                return _.sum(_.map(this.results.equipment_based_plans, (plan) => plan.leads));
            }
            return 0;
        },
        allMcLeads() {
            return this.results.selected_mc_leads + this.results.selected_mc_oo_leads + this.results.selected_mc_student_leads;
        },
        hireEstimate() {
            return this.allDejaLeads / 50;
        },
        totalDriverBoost() {
            if (this.results.driverboost_plans) {
                let cdIndex = _(this.results.driverboost_plans.db_cd)
                    .keyBy(x => x.leads)
                    .mapValues(x => parseInt(x.monthly_price))
                    .value();
                let ooIndex = _(this.results.driverboost_plans.db_oo)
                    .keyBy(x => x.leads)
                    .mapValues(x => parseInt(x.monthly_price))
                    .value();
                let studentIndex = _(this.results.driverboost_plans.db_student)
                    .keyBy(x => x.leads)
                    .mapValues(x => parseInt(x.monthly_price))
                    .value();

                return cdIndex[this.results.selected_driverboost_leads || 0]
                    + ooIndex[this.results.selected_driverboost_oo_leads || 0]
                    + studentIndex[this.results.selected_driverboost_student_leads || 0];
            }
            if (this.results.equipment_based_plans) {
                return _.sum(_.map(this.results.equipment_based_plans, (plan) => plan.leads * plan.price));
            }
            return 0;
        },
        totalMultiCarrier() {
            return  this.results.selected_mc_leads * this.mc_lead_price
                + this.results.selected_mc_oo_leads * this.mc_oo_lead_price
                + this.results.selected_mc_student_leads * this.mc_student_lead_price
        },
        totalDiscounts() {
            return (this.results.discounts_250_ja ? 250 : 0)
            + (this.results.discounts_500_ja ? 500 : 0)
            + (this.results.discounts_1000_ja ? 1000 : 0);
        },
        total() {
            let discounts = (this.results.discounts_250 ? 250 : 0)
                + (this.results.discounts_500 ? 500 : 0)
                + (this.results.discounts_waive_fee_500 ? 500 : 0)
                + (this.results.discounts_waive_fee_750 ? 750 : 0)
                + (this.results.discounts_250_ja ? 250 : 0)
                + (this.results.discounts_500_ja ? 500 : 0)
                + (this.results.discounts_1000_ja ? 1000 : 0);
            let addons = Number(this.results.addon_price);

            return 1000 +
                + addons
                + this.totalMultiCarrier
                + this.totalDriverBoost
                - discounts;
        }
    },
    methods: {
        // logo
        handleLogoRemove() {
            this.results.logo_url = null;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        logoUploaded(response) {
            this.results.logo_url = response;
        },

        setMcLeads(value) {
            if (value == 'custom') {
                this.results.selected_mc_leads = parseInt(this.custom_mc_cd_leads);
            }
            else {
                this.results.selected_mc_leads = value;
            }
        },
        setMcOOLeads(value) {
          if (value == 'custom') {
            this.results.selected_mc_oo_leads = parseInt(this.custom_mc_oo_leads);
          }
          else {
            this.results.selected_mc_oo_leads = value;
          }
        },
        setMcStudentLeads(value) {
          if (value == 'custom') {
            this.results.selected_mc_student_leads = parseInt(this.custom_mc_student_leads);
          }
          else {
            this.results.selected_mc_student_leads = value;
          }
        },
        saveResults() {
            this.loading = true;
            return axios.post(url(`admin/proposal/${this.id}/results`), {
                    pricelist: this.results.pricelist,
                    plan: this.results.selected_plan,
                    driverboost_leads: this.results.selected_driverboost_leads,
                    driverboost_oo_leads: this.results.selected_driverboost_oo_leads,
                    driverboost_student_leads: this.results.selected_driverboost_student_leads,
                    equipment_based_plans: this.results.equipment_based_plans,
                    mc_leads: this.results.selected_mc_leads,
                    mc_oo_leads: this.results.selected_mc_oo_leads,
                    mc_student_leads: this.results.selected_mc_student_leads,
                    discounts_250_ja: this.results.discounts_250_ja,
                    discounts_500_ja: this.results.discounts_500_ja,
                    discounts_1000_ja: this.results.discounts_1000_ja,
                    term_length: this.results.selected_term_length,
                    price: this.results.selected_price,
                    addon_price: this.results.addon_price,
                    addon_note: this.results.addon_note,

                    logo_url: this.results.logo_url,
                    pricing_option1: this.results.pricing_option1,
                    pricing_option3: this.results.pricing_option3,
                    discount_option1: this.results.discount_option1,
                    discount_option2: this.results.discount_option2,
                    discount_option3: this.results.discount_option3,
                    please_sign_by: this.results.please_sign_by,
                    pricing_option_description1: this.results.pricing_option_description1,
                    pricing_option_description2: this.results.pricing_option_description2,
                    pricing_option_description3: this.results.pricing_option_description3,
                }).then(response => {
                    this.$confirm(
                        'All data saved! You can stay on the current page or go to the Proposal List.',
                        'Proposal saved', {
                            confirmButtonText: 'Return to Proposal List',
                            cancelButtonText: 'Continue'
                        })
                        .then(() => {
                            window.location.href = url(`admin/proposal/list`);
                        });
                }).finally(() => {
                    this.loading = false;
                });
        },
        previewProposal() {
            window.open(url(`our-proposal/${this.results.key}`));
        },
        leadsPlanName(leads, price) {
            return leads ? leads+' leads (+'+this.money(leads * price, 0)+')' : 'no Driver Boost';
        },
        isDBSelectable(currentItemIndex, leadsAvailableItem, currentLeadsItem) {
            const leadsAvailable = this.results.driverboost_available[leadsAvailableItem];
            const currentItemLeads = this.results.driverboost_plans[currentLeadsItem][currentItemIndex].leads;
            const previousItemLeads = currentItemIndex > 0 ? this.results.driverboost_plans[currentLeadsItem][currentItemIndex - 1].leads : 0;

            return this.isSelectable(leadsAvailable, currentItemLeads, previousItemLeads);
        },
        isSelectable(leadsAvailable, currentLeads, previousLeads) {
            if (currentLeads == 0) return true;
            else if (leadsAvailable >= currentLeads) return true;
            else if (leadsAvailable < currentLeads && leadsAvailable > previousLeads) return true;

            return false;
        },
        resetOldDiscounts() {
            Vue.set(this.results, 'discounts_250', false);
            Vue.set(this.results, 'discounts_500', false);
            Vue.set(this.results, 'discounts_waive_fee_500', false);
            Vue.set(this.results, 'discounts_waive_fee_750', false);
        }
    },
    mounted() {
    }
}
</script>

<style>
.btn-large {
    padding: 14px 20px;
    font-size: 20px;
    line-height: 1.4;
    border-radius: 6px;
}
</style>
